/*eslint-disable no-underscore-dangle*/
import Core from "../core/Core";
import EQOnClickManager from "./EQOnClickManager";
import * as Constants from "../core/Constants";
import VersionParser from "../core/utils/VersionParser";

// https://curiosity-driven.org/private-properties-in-javascript
// https://esdiscuss.org/topic/es6-problem-with-private-name-objects-syntax
// https://leanpub.com/understandinges6/read

var privateState = new WeakMap();
function createPrivateState(o) {
    privateState.set(o, {});
}
function _private(o) { // "private" is a reserved keyword
    return privateState.get(o);
}

/**
 * EQualOne SDK Core public APIs
 */

export default class EQCore {

    constructor() {
        if (window["chrome"] && window["chrome"].runtime && window["chrome"].runtime.onConnect) {
            window["chrome"].runtime.onConnect.addListener((externalPort) => {
                externalPort.onDisconnect.addListener(() => {
                    _private(this).core.disconnectFromBackgroundPage();
                });
            });
        }

        createPrivateState(this);
    }

    /**
     * Init the SDK
     *
     * @param url The server URL
     * @param folder The folder
     * @param configurationCallback Optional A configuration callback with 2 parameters (status, error)
     * @param routerCallback Optional A router callback with 1 parameter (error)
     * @param routerIp The router IP address (if null, auto detect)
     * @param routerUsername The router username (if null, default username)
     * @param routerPassword The router password (if null, default password)
     * @param discoverGateway Au to discover gateway. Default is false.
     */
    init(url, folder, configurationCallback = null, routerCallback = null, routerIp = null, routerUsername = null, routerPassword = null, discoverGateway = false) {
        _private(this).core = new Core(url, folder);
        this.onClickManager = new EQOnClickManager(_private(this).core);
        _private(this).core.init(configurationCallback, routerCallback, routerIp, routerUsername, routerPassword, discoverGateway);
    }

    /**
     * Force the configuration update from the server, or call a coupon
     *
     * @param callback Optional A configuration callback with 2 parameters (status, error)
     * @param coupon Optional A coupon to get a specific scenario
     */
    updateConfig(callback = null, coupon = null) {
        if (!_private(this).core) throw Error('Call init method first');
        _private(this).core.updateConfig(callback, coupon);
    }

    /**
     * Set a reverse geocoding function to enrich GPS data from client side
     * The callback should get 3 parameters
     * The 3rd parameter (callback) should have 1 parameter : the reverse geocoding data, under the following format :
     * {city: "City", country: "Country", countryCode: "CO", postalCode: "12345", streetNumber: "1", streetName: "Quality street"}
     *
     * @param reverseGeocodingFunction A function with 3 parameters (latitude, longitude, another callback to alert SDK when enrichment is successfully done)
     */
    setReverseGeocodingFunction(reverseGeocodingFunction) {
        if (!_private(this).core) throw Error('Call init method first');
        _private(this).core.setReverseGeocodingFunction(reverseGeocodingFunction);
    }

    /**
     * Add a custom field
     *
     * @param key
     * @param value
     */
    addCustomField(key, value) {
        if (!_private(this).core) throw Error('Call init method first');
        _private(this).core.addCustomField(key, value);
    }

    /**
     * Remove a custom field
     *
     * @param key
     */
    deleteCustomField(key) {
        if (!_private(this).core) throw Error('Call init method first');
        _private(this).core.deleteCustomField(key);
    }

    /*
     * Returns the SDK version object
     *
     * @return SDK version (object)
     */
    getVersion() {
        let version = {
            "version": Constants.AGENT_VERSION,
            "build": VersionParser.parseVersion(Constants.AGENT_VERSION)
        };
        return version;
    }

    /**
     * Enable logs for SDK
     *
     * @param status
     */
    enableLogs(status = true) {
        window.equaloneLoggerEnabled = status;
    }

    /**
     * Set the router informations
     *
     * @param callback a callback with an error
     * @param ip An ip address
     * @param username A router's username
     * @param password A router's password
     */
    setRouterAccessInformations(callback = null, ip = null, username = null, password = null) {
        _private(this).core.setGatewayAccessInformations(callback, ip, username, password);
    }
}



// WEBPACK FOOTER //
// ./js/public-apis/EQCore.js